<div class="packet-summary">
  <div class="wrapper">
    <div class="wrap-logo">
      <img class="logo" src="assets/images/bbreport_logo.png">
      <span class="wrap-logo-desc">
        <div class="center-name">{{center}}</div>
        <div class="packet-name">{{packetName}}</div>
      </span>
    </div>
    <div class="wrap-term">
      <div class="desc">
        <span class="tit">시작</span><img class="img-arrow" src="assets/images/bbreport_hs.png"><span>{{packetStart}}</span>
      </div>
      <div class="desc">
        <span class="tit">종료</span><img class="img-arrow" src="assets/images/bbreport_hs.png"><span>{{packetEnd}}</span>
      </div>
    </div>
  </div>
</div>
